import { EMPTY_STRING } from '../../../../constants/common'
import {
  linkifyHtml,
  openHtmlLinksInNewTab,
  toDocument,
} from '../../../../utils/html'
import { newLineToBrInEmailText } from '../../Email.utils'

export function prepareRawMessageHtml({ rawText, text }) {
  const doc = toDocument(rawText || newLineToBrInEmailText(text))

  /* Collect all <style> blocks from <head>.
    Many email templates keep global CSS there (including @import for fonts). 
  */
  const headStyles = Array.from(doc.head.querySelectorAll('style'))
    .map(s => s.textContent || EMPTY_STRING)
    .filter(Boolean)

  /* Extract inline styles from <html> and <body>.
    When we insert HTML via dangerouslySetInnerHTML, tags like <html>/<body>
    are not rendered as actual document-level nodes, so their styles would be lost. 
  */
  const htmlStyle = doc.documentElement.getAttribute('style') || EMPTY_STRING
  const bodyStyle = doc.body.getAttribute('style') || EMPTY_STRING
  const bodyClass = doc.body.getAttribute('class') || EMPTY_STRING

  /* Create a clean output HTML document that will act as a "container"
    for the transformed markup we return.
  */
  const out = document.implementation.createHTMLDocument(EMPTY_STRING)

  /* 1) Re-insert collected <head> styles into the triggering HTML fragment.
    We append a <style> node at the top so CSS is available inside the container.
  */
  if (headStyles.length > 0) {
    const styleEl = out.createElement('style')

    styleEl.textContent = headStyles.join('\n')
    out.body.appendChild(styleEl)
  }

  /* 2) Create a wrapper element that will receive the <body> contents.
    We apply <html> + <body> inline styles to this wrapper so the visual result
    matches what would have been applied at document level.
  */
  const wrapper = out.createElement('div')

  /* IMPORTANT: use setAttribute instead of string interpolation in HTML.
    This ensures quotes in values (e.g. font-family: "Lato", ...) are properly escaped
    and the resulting CSS stays valid.
  */
  const mergedStyle = [htmlStyle, bodyStyle].filter(Boolean).join('; ')

  if (mergedStyle) {
    wrapper.setAttribute('style', mergedStyle)
  }

  if (bodyClass) {
    wrapper.setAttribute('class', bodyClass)
  }

  // Insert the body content from the original document into the wrapper
  wrapper.innerHTML = openHtmlLinksInNewTab(linkifyHtml(doc.body.innerHTML))
  out.body.appendChild(wrapper)

  /* Return only the fragment that should be inserted via dangerouslySetInnerHTML.
    This will contain:
    - a <style> tag with head CSS (if any)
    - a wrapper <div> with merged <html>/<body> styles and body content inside
  */
  return out.body.innerHTML
}
